import Body from '~/components/Modal/Body/Body';

export default Body;
